import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { useTranslation } from 'react-i18next';
import { BaseEntity } from 'shared/types/general';

interface CategoryFormProps {
  type: BaseEntity;
  onSubmit: any;
}
function TypeForm(props: CategoryFormProps) {
  const { t } = useTranslation();
  const { type, onSubmit } = props;

  return (
    <div>
      {type && (
        <EnhancedForm onSubmit={onSubmit} edit={!!type.id} autoStyleLayout columns={5}>
          <IdentityField
            gridSpan={2}
            name="code"
            component={TextFieldAdapter}
            initialValue={type.code}
            label={t('global.code')}
            placeholder={t('global.code')}
            type="text"
          />
          <IdentityField
            gridSpan={3}
            name="description"
            component={TextFieldAdapter}
            initialValue={type.description}
            label={t('global.description')}
            placeholder={t('global.description')}
            type="text"
          />
        </EnhancedForm>
      )}
    </div>
  );
}

export default TypeForm;
